var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"a"}},[_c('div',{staticClass:"num"},[_vm._v("\n    "+_vm._s(_vm.count)+"\n  ")]),_vm._v(" "),(_vm.type == 'textarea')?_c('b-form-textarea',{class:_vm.classes,attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxlength":_vm.maxlength},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d478abf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/CountTextArea.vue
// module id = 1484
// module chunks = 0